import { createSlice } from '@reduxjs/toolkit';

import { ProductCategoryDto } from '../../../../types/products';
import { SLICE_BASE_NAME } from '../../auth/constant';

const initialState: ProductCategoryDto = {
  name: '',
  description: '',
};

const categorySlice = createSlice({
  name: `${SLICE_BASE_NAME}/products/category`,
  initialState,
  reducers: {
    addCategory(state, action) {
      state.name = action.payload.name;
      state.description = action.payload.description;
    },
  },
});

export const { addCategory } = categorySlice.actions;
export default categorySlice.reducer;
